// client/src/config/maintenance.js
// v2 전환 기간 운영 플래그. 10/10 v2 배포 시 이 파일과 사용처를 제거한다.
// 서버 측 플래그: server/.env 의 PROJECT_CREATION_PAUSED (routes/index.js 참조)

/** 신규 프로젝트 생성 차단 여부 */
export const PROJECT_CREATION_PAUSED = true;

/** 업데이트 예고 팝업 노출 여부 */
export const V2_NOTICE_POPUP_ENABLED = true;

/** 안내 문구용 일자 텍스트 */
export const V2_UPDATE_DATE_TEXT = '10월 10일';

/** D-day 계산 기준: 10/10 자정 (달력일 기준) */
export const V2_UPDATE_DAY_START = new Date('2026-10-10T00:00:00+09:00').getTime();

/**
 * 이 시각 이후 팝업 신규 노출 중단. 운영 배포 창구(01~02시 KST)를 고려해 03:00으로 설정
 * — 10/10 00:00~새벽 배포 사이에 "10월 10일부터 가능합니다" 팝업이 새로 뜨는 모순 방지
 */
export const V2_UPDATE_AT = new Date('2026-10-10T03:00:00+09:00').getTime();

/** 다시 안 보기 저장 키(차수 네임스페이스 — 문구 개정 후 재노출이 필요하면 :2로 올림) / 기간 */
export const V2_NOTICE_HIDE_KEY = 'v2NoticeHideUntil:1';
export const V2_NOTICE_HIDE_DAYS = 7;
